export default {"src":"/_next/static/media/loading-arrows.0483078f.svg","height":32,"width":29,"blurWidth":0,"blurHeight":0};